import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-iniciar-atendimento-chat',
  templateUrl: './modal-iniciar-atendimento-chat.component.html',
  styleUrls: ['./modal-iniciar-atendimento-chat.component.scss']
})
export class ModalIniciarAtendimentoChatComponent implements OnInit {
  @Input() chat: any;
  @Input() filas: any[] = [];
  @Input() integracao: any;
  @Input() nomeEmpresa: string = '';
  @Input() operador: string = '';
  @Input() mostrarTemplateMeta: boolean = false;
  @Input() filaInicialId: number = null;

  filaSelecionada: any = null;
  templateSelecionado: any = null;
  templateContent: string = null;
  templateHeader: string = null;
  templateFooter: string = null;
  disabledTemplateDropDown: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
    if (this.filaInicialId) {
      this.filaSelecionada = this.filas.find(fila => Number(fila.id) === Number(this.filaInicialId)) || null;
    }

    if (!this.filaSelecionada && this.filas.length === 1) {
      this.filaSelecionada = this.filas[0];
    }
  }

  close(result?: any): void {
    this.activeModal.close(result || false);
  }

  selecionarFila(fila: any): void {
    this.filaSelecionada = fila || null;
  }

  retornoSelectTemplatesMeta(event: any): void {
    this.disabledTemplateDropDown = false;
    const templates = Array.isArray(event) ? event : event?.lista || [];

    if (this.mostrarTemplateMeta && this.integracao?.provider_id === 4 && !templates.length) {
      Swal.fire({
        text: this.translate.instant('ALERTA_SEM_TEMPLATE_META'),
        icon: 'warning',
        confirmButtonText: 'Ok'
      });
      this.close();
      return;
    }

    if (templates.length === 1 && this.integracao?.provider_id === 4) {
      const aplicouTemplate = this.changeTemplateProperties(this.normalizarTemplateMeta(templates[0]));
      this.disabledTemplateDropDown = aplicouTemplate;
    }
  }

  changeTemplateProperties(properties: any): boolean {
    if (!properties) {
      this.limparTemplateSelecionado();
      return false;
    }

    if (properties?.status === 'Bloqueado(Config. Variável)' || properties?.status === 'Bloqueado') {
      this.limparTemplateSelecionado();
      Swal.fire({
        text: this.translate.instant('ALERTA_TEMPLATE_BLOQUEADO'),
        icon: 'warning',
        confirmButtonText: 'Ok',
        position: 'top'
      });
      return false;
    }

    const marcadores = [
      { chave: '{{Contato}}', valor: this.chat?.contato?.descricao || '' },
      { chave: '{{Empresa}}', valor: this.nomeEmpresa || '' },
      { chave: '{{Operador}}', valor: this.operador || '' },
      { chave: '{{Ticket}}', valor: 'Não Possui' },
      { chave: '{{Protocolo}}', valor: this.chat?.protocolo || 'Não Possui' },
      { chave: '{{Assunto}}', valor: 'Não Possui' },
      { chave: '{{contato}}', valor: this.chat?.contato?.descricao || '' },
      { chave: '{{empresa}}', valor: this.nomeEmpresa || '' },
      { chave: '{{operador}}', valor: this.operador || '' },
      { chave: '{{ticket}}', valor: 'Não Possui' },
      { chave: '{{protocolo}}', valor: this.chat?.protocolo || 'Não Possui' },
      { chave: '{{assunto}}', valor: 'Não Possui' }
    ];

    const substituirMarcadores = (texto: string) =>
      marcadores.reduce((acc, item) => acc?.replaceAll(item.chave, item.valor), texto);

    const variaveisContent = marcadores
      .filter(item => properties?.content?.includes(item.chave))
      .map(item => item.valor);

    const variaveisHeader = marcadores
      .filter(item => properties?.header?.includes(item.chave))
      .map(item => item.valor);

    const variaveisDescricaoOriginal = marcadores
      .filter(item => properties?.descricao_original?.includes(item.chave))
      .map(item => item.chave?.replace(/[{}]/g, ''));

    const variaveisHeaderOriginal = marcadores
      .filter(item => properties?.header_original?.includes(item.chave))
      .map(item => item.chave?.replace(/[{}]/g, ''));

    const content = substituirMarcadores(properties.content);
    const header = substituirMarcadores(properties.header);

    this.templateSelecionado = {
      template_name: properties.title,
      language: properties.lang,
      template_content: content,
      variaveis_content: variaveisContent,
      variaveis_header: variaveisHeader,
      variaveis_descricao_original: variaveisDescricaoOriginal,
      variaveis_header_original: variaveisHeaderOriginal
    };

    this.templateContent = content;
    this.templateHeader = header;
    this.templateFooter = properties.footer;
    return true;
  }

  podeIniciar(): boolean {
    if (!this.filaSelecionada?.id) {
      return false;
    }

    if (this.mostrarTemplateMeta) {
      return !!this.templateSelecionado?.template_name && !!this.templateSelecionado?.template_content;
    }

    return true;
  }

  confirmar(): void {
    if (!this.podeIniciar()) {
      return;
    }

    this.close({
      fila_atendimento_id: this.filaSelecionada.id,
      template: this.templateSelecionado
    });
  }

  obterCanal(): string {
    if (this.chat?.widget?.descricao) {
      return this.chat.widget.descricao;
    }

    if (this.chat?.is_whatsapp) {
      return 'WhatsApp';
    }

    if (this.chat?.is_telegram) {
      return 'Telegram';
    }

    if (this.chat?.is_messenger) {
      return 'Messenger';
    }

    return '';
  }

  obterNumeroContato(): string {
    const numero = this.chat?.contato?.celular || this.chat?.contato?.telefone || this.chat?.numero_contato || '';
    return this.formatarNumero(numero);
  }

  private limparTemplateSelecionado(): void {
    this.templateSelecionado = null;
    this.templateContent = null;
    this.templateHeader = null;
    this.templateFooter = null;
  }

  private normalizarTemplateMeta(template: any): any {
    if (!template) {
      return null;
    }

    if (template.title || template.content) {
      return template;
    }

    return {
      title: template.titulo,
      lang: template.language,
      status: template.status,
      content: template.descricao,
      header: template.header,
      footer: template.footer,
      descricao_original: template.descricao_original,
      header_original: template.header_original
    };
  }

  private formatarNumero(numero: string): string {
    if (!numero) {
      return '';
    }

    const numeroLimpo = String(numero).replace(/\D/g, '');
    const numeroSemPais = numeroLimpo.startsWith('55') && numeroLimpo.length > 11
      ? numeroLimpo.slice(2)
      : numeroLimpo;

    if (numeroSemPais.includes('0800')) {
      return `${numeroSemPais.slice(0, 4)} ${numeroSemPais.slice(4, 7)} ${numeroSemPais.slice(7, 11)}`.trim();
    }

    switch (numeroSemPais.length) {
      case 10:
        return `(${numeroSemPais.slice(0, 2)}) ${numeroSemPais.slice(2, 6)}-${numeroSemPais.slice(6)}`;
      case 11:
        return `(${numeroSemPais.slice(0, 2)}) ${numeroSemPais.slice(2, 7)}-${numeroSemPais.slice(7)}`;
      default:
        return numeroSemPais;
    }
  }
}
